module.exports = __webpack_public_path__ + "img/kvbackground.da7e801d.jpg";